import axios from 'axios';
import { toast } from 'react-hot-toast';


const API_URL = process.env.REACT_APP_API_HOST

export const getSiteType = () => {
    return async (dispatch) => {
        try {
            dispatch({ type: 'SITE_TYPE_REQUEST' });
            const { data } = await axios.get(`${API_URL}/site-type`);
            dispatch({ type: 'SITE_TYPE_SUCCESS', siteType: data });
        }
        catch (error) {
            dispatch({ type: 'SITE_TYPE_FAILURE', error: error.message });
        }
    }
}

export const createSiteType = (siteType) => {
    return async (dispatch) => {
        try {
            dispatch({ type: 'SITE_TYPE_CREATE_REQUEST' });
            const { data } = await axios.post(`${API_URL}/site-type`, siteType, {
                headers: {
                    Authorization: localStorage.getItem('xat')
                }
            });
            dispatch({ type: 'SITE_TYPE_CREATE_SUCCESS', siteType: data });
            toast.success('Room added successfully!');
        } catch (error) {
            toast.error(error.response.data.message);
            dispatch({ type: 'SITE_TYPE_CREATE_FAILURE', error: error.message });
        }
    }
}

export const updateSiteType = (id, siteType) => {
    return async (dispatch) => {
        try {
            dispatch({ type: 'SITE_TYPE_UPDATE_REQUEST' });
            const { data } = await axios.put(`${API_URL}/site-type/${id}`, siteType, {
                headers: {
                    Authorization: localStorage.getItem('xat')
                }
            });
            dispatch({ type: 'SITE_TYPE_UPDATE_SUCCESS', siteType: data });
            toast.success('Room updated successfully!');
        } catch (error) {
            toast.error(error.response.data.message);
            dispatch({ type: 'SITE_TYPE_UPDATE_FAILURE', error: error.message });
        }
    }
}

export const deleteSiteType = (id) => {
    return async (dispatch) => {
        try {
            dispatch({ type: 'SITE_TYPE_DELETE_REQUEST' });
            const config = {
                headers: {
                    Authorization: localStorage.getItem('xat')
                }
            }
            const { data } = await axios.delete(`${API_URL}/site-type/${id}`, config);
            dispatch({ type: 'SITE_TYPE_DELETE_SUCCESS', siteType: data });
            toast.success('Room deleted successfully!');
        } catch (error) {
            dispatch({ type: 'SITE_TYPE_DELETE_FAILURE', error: error.message });
        }
    }
}

export const setRedirect = () => {
    return async (dispatch) => {
        try {
            dispatch({ type: 'SET_REDIRECT' });
        } catch (error) {
            dispatch({ type: 'SET_REDIRECT', error: error.message });
        }
    }
} 